export default function InitVideoLightbox() {
	const lightbox = document.getElementById('videoLightbox');
	if (!lightbox) return;

	const video = lightbox.querySelector('.video-lightbox__video');
	const overlay = lightbox.querySelector('.video-lightbox__overlay');
	const closeBtn = lightbox.querySelector('.video-lightbox__close');
	const triggers = document.querySelectorAll('.btn-play-video');

	function open() {
		lightbox.classList.add('is-active');
		video.play();
	}

	function close() {
		lightbox.classList.remove('is-active');
		video.pause();
		video.currentTime = 0;
	}

	triggers.forEach((btn) => {
		btn.addEventListener('click', (e) => {
			e.preventDefault();
			open();
		});
	});

	closeBtn.addEventListener('click', close);
	overlay.addEventListener('click', close);

	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape' && lightbox.classList.contains('is-active')) {
			close();
		}
	});
}
